// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-nav[data-v-81de2526]{display:flex;height:64px;position:fixed;top:0;left:0;width:100%;z-index:100;transition:all .2s ease;font-size:14px}.editor-nav-logo[data-v-81de2526]{margin-left:24px;margin-right:72px;cursor:pointer}.editor-nav-left[data-v-81de2526]{flex:2;display:flex;align-items:center}.editor-nav-right[data-v-81de2526]{display:flex;flex-direction:row;justify-content:flex-end;align-items:center}.editor-nav-right .user[data-v-81de2526]{margin-right:24px}", ""]);
// Exports
module.exports = exports;
